import React from 'react'
import { Typography } from '@material-ui/core'
import { ModalConfirmacao } from 'components'

export const ModalContraprova = (props) => {
  const { aberto, onClose, onConfirm, processando, identificador } = props

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      titulo="TORNAR CONTRAPROVA"
      confirmarLabel="Confirmar"
      maxWidth="sm"
    >
      <Typography variant="body1" style={{ marginTop: '10px' }}>
        O vestígio <strong>{identificador}</strong> se tornará uma contraprova. Tem certeza que deseja prosseguir?
      </Typography>
    </ModalConfirmacao>
  )
}
